export const API_KEY = 'AIzaSyARk5fP16WEBttVGsZpB1kps2GQBB0tFw8';
